import { NavItemDef } from '../navItems';

export const PERFORMANCE_REPORTING_NAV_ITEMS: NavItemDef[] = [
  {
    key: 'performanceReporting.fieldBank',
    label: 'performanceReporting.navItems.fieldBank',
    path: 'field-bank',
    permissions: ['viewFieldBank'],
    visibility: ({ currentOrganizationId }) => {
      return currentOrganizationId === 'lexipoladminstaffuuid'; // TODO: Remove this once we have a proper permission check
    },
  },
  {
    key: 'performanceReporting.templateManagement',
    label: 'performanceReporting.navItems.templateManagement',
    path: 'templates',
    permissions: ['viewFieldBank'],
  },
  {
    key: 'performanceReporting.reviewWorkflows',
    label: 'performanceReporting.navItems.reviewWorkflows',
    path: 'review-workflows',
    permissions: ['viewReviewWorkflow'],
    visibility: ({ currentOrganizationId }) => {
      return currentOrganizationId !== 'lexipoladminstaffuuid'; // Only show for Agency Admins, not Lexipol staff
    },
  },
  {
    key: 'performanceReporting.earlyInterventionSystem',
    label: 'performanceReporting.navItems.earlyInterventionSystem',
    path: 'early-intervention-system',
    permissions: ['viewEarlyInterventionSystem'],
    visibility: ({ currentOrganizationId }) => {
      return currentOrganizationId !== 'lexipoladminstaffuuid'; // Only show for Agency Admins, not Lexipol staff
    },
  },
];
